import React from 'react';
import { Outlet } from "react-router-dom";
import ChatAiSidebar from "./ChatAiSidebar";
import Contact from './ContactUs';
import Header from "./Header";

const languageDataKeys = {
  mn: "Mongolian",
  en: "English",
  ko: "Korean",
  jp: "Japanese",
  de: "German",
  se: "Swedish",
  fr: "French",
  es: "Spanish",
  ru: "Russian",
  zh: "Chinese",
  tr: "Turkish",
  kz: "Kazakh",
  uz: "Uzbek",
  az: "Azerbaijani",
  tj: "Tajik",
  kg: "Kyrgyz",
  tm: "Turkmen",
  ar: "Arabic",
};

const deepMerge = (base, override) => {
  if (override === undefined) {
    return base;
  }

  if (!base || typeof base !== "object" || Array.isArray(base)) {
    return override;
  }

  if (!override || typeof override !== "object" || Array.isArray(override)) {
    return override;
  }

  return Object.keys(base).reduce(
    (merged, key) => ({
      ...merged,
      [key]: deepMerge(base[key], override[key]),
    }),
    { ...override }
  );
};

const Layout = ({ data, language}) => {
  const getLanguageData = (lang) => {
    const languageKey = languageDataKeys[lang] || languageDataKeys.mn;
    const languageData = data[languageKey] || {};

    return languageKey === "English"
      ? data.English
      : deepMerge(data.English, languageData);
  };
  
  const langData = getLanguageData(language);
  
  return (
    <>
      <Header
        // title={langData.Title}
        data={{...langData.Header, ...langData.Contact, team: langData.Members.title1, tests: langData.Tests.title}}
      />
      <Outlet />
      <ChatAiSidebar data={langData.ChatAi} />
      <Contact
        data={langData.Contact}
      />
    </>
  )
};

export default Layout;
